import {
  NonStockedSSDTab,
  ExceptionTestingTab,
  ReshipmentsTab,
  AncillaryMaterialsTab,
  OrdersAfterDeadlineTab,
} from './tabs'
import {
  APPROVALS_NONSTOCKED_SSD_TAB,
  APPROVALS_EXCEPTION_TESTING_TAB,
  APPROVALS_RESHIPMENTS_TAB,
  APPROVALS_ANCILLARY_MATERIALS_TAB,
  APPROVALS_ORDERS_AFTER_DEADLINE_TAB,
  APPROVALS_OFFCYCLE_TESTING_TAB,
} from '../../constants/TabConstants'
import { NAV_LINKS } from '../../constants/NavConstants'
import { fetchApprovalTabCounts } from '../../actions/tabs'
import { selectApprovalTabCounts } from '../../selectors/approvalTabCounts'
import Tabs from '../common/Tabs'
import { OffCycleTestingTab } from './tabs/OffCycleTestingTab'

const mapStateToProps = state => {
  const {
    nonStockedSSDs,
    ancillaryMaterials,
    exceptionTests,
    offCycle,
    orderedAfterDeadlines,
    reshipments,
  } = selectApprovalTabCounts(state)

  return {
    nonStockedSSDs,
    ancillaryMaterials,
    exceptionTests,
    offCycle,
    orderedAfterDeadlines,
    reshipments,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ fetchApprovalTabCounts }, dispatch)

export class ApprovalRequestsNavTabs extends Component {
  componentDidMount() {
    const { fetchApprovalTabCounts } = this.props

    fetchApprovalTabCounts()
  }

  render() {
    const {
      nonStockedSSDs,
      ancillaryMaterials,
      exceptionTests,
      orderedAfterDeadlines,
      offCycle,
      reshipments,
    } = this.props
    return (
      <Tabs
        page={NAV_LINKS.approvals}
        tabs={[
          {
            label: 'Non-Stocked SSD',
            count: nonStockedSSDs,
            Component: NonStockedSSDTab,
            compId: APPROVALS_NONSTOCKED_SSD_TAB,
            isDefault: true,
          },
          {
            label: 'Exception Testing',
            count: exceptionTests,
            Component: ExceptionTestingTab,
            compId: APPROVALS_EXCEPTION_TESTING_TAB,
          },
          {
            label: 'Reshipments',
            count: reshipments,
            Component: ReshipmentsTab,
            compId: APPROVALS_RESHIPMENTS_TAB,
          },
          {
            label: 'Ancillary Materials',
            count: ancillaryMaterials,
            Component: AncillaryMaterialsTab,
            compId: APPROVALS_ANCILLARY_MATERIALS_TAB,
          },
          {
            label: 'Orders After Deadline',
            count: orderedAfterDeadlines,
            Component: OrdersAfterDeadlineTab,
            compId: APPROVALS_ORDERS_AFTER_DEADLINE_TAB,
          },
          {
            label: 'Off-Cycle Testing',
            count: offCycle,
            Component: OffCycleTestingTab,
            compId: APPROVALS_OFFCYCLE_TESTING_TAB,
          },
        ]}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalRequestsNavTabs)
